export default class CountryCodeService 
{
    GetCountryCode() {
        return fetch('data/countrycode.json').then(res => res.json()).then(d => d.data);
    }

}